import { nextTick } from "vue";
import gsap from "gsap";
export function displayFadeoutMessageToUser(message) {
    MessageToDisplayContainer.addToDisplayQueue(message);
}
export class MessageToDisplayContainer {
    static init(messageInTemplateRef) {
        MessageToDisplayContainer.messageInTemplateRef = messageInTemplateRef;
        if (this.isInitialized) {
            return;
        }
        MessageToDisplayContainer.messagesToDisplay = [];
        this.isInitialized = true;
    }
    static addToDisplayQueue(message) {
        this.messagesToDisplay.push(message);
        if (!MessageToDisplayContainer.displayOpen) {
            MessageToDisplayContainer.displayFirstMessage();
        }
    }
    static displayFirstMessage() {
        const message = this.messagesToDisplay.shift();
        if (!message) {
            return;
        }
        this.displayOpen = true;
        MessageToDisplayContainer.messageInTemplateRef.value = message;
        nextTick().then(() => MessageToDisplayContainer.displayFeedbackPopup().then(() => {
            MessageToDisplayContainer.displayOpen = false;
            MessageToDisplayContainer.displayFirstMessage();
        }));
    }
    static setOptions(target, duration) {
        MessageToDisplayContainer.options.target = target;
        MessageToDisplayContainer.options.duration = duration;
    }
    static displayFeedbackPopup() {
        return new Promise(resolve => {
            gsap.to(MessageToDisplayContainer.options.target, {
                zIndex: 999999,
                opacity: 1,
                duration: MessageToDisplayContainer.options.duration,
            }).then(() => gsap.to(MessageToDisplayContainer.options.target, { zIndex: -1, opacity: 0, duration: 1.0 })).then(() => resolve());
        });
    }
}
MessageToDisplayContainer.messagesToDisplay = [];
MessageToDisplayContainer.isInitialized = false;
MessageToDisplayContainer.displayOpen = false;
MessageToDisplayContainer.options = {
    target: ".km__module_feedback",
    duration: 0.8
};
//# sourceMappingURL=MessageToDisplayContainer.js.map